// extracted by mini-css-extract-plugin
export default {"suitor":"style_suitor__zO-b1","table_container":"style_table_container__lsVIm","donationSuitor":"style_donationSuitor__kCd9w"};